"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var addMonths_1 = tslib_1.__importDefault(require("date-fns/addMonths"));
var format_1 = tslib_1.__importDefault(require("date-fns/format"));
var sk_1 = tslib_1.__importDefault(require("date-fns/locale/sk"));
var subMonths_1 = tslib_1.__importDefault(require("date-fns/subMonths"));
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var MonthSelectorWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-bottom: ", ";\n"])), polished_1.rem(16));
var MonthName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  text-transform: capitalize;\n  margin-left: ", ";\n  margin-right: ", ";\n"], ["\n  font-size: ", ";\n  text-transform: capitalize;\n  margin-left: ", ";\n  margin-right: ", ";\n"])), polished_1.rem(16), polished_1.rem(4), polished_1.rem(4));
var MonthSwitchButton = styled_components_1["default"].button(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  background-color: transparent;\n  color: ", ";\n  border: none;\n  cursor: pointer;\n  :hover {\n    font-weight: bold;\n  }\n"], ["\n  background-color: transparent;\n  color: ", ";\n  border: none;\n  cursor: pointer;\n  :hover {\n    font-weight: bold;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.app.textColor;
});
var MonthSwitcher = function (_a) {
    var date = _a.date, onMonthChange = _a.onMonthChange;
    return (React.createElement(MonthSelectorWrapper, null,
        React.createElement(MonthSwitchButton, { onClick: function () {
                onMonthChange(subMonths_1["default"](date, 1));
            } }, '<<'),
        React.createElement(MonthName, null, format_1["default"](date, 'LLLL', {
            locale: sk_1["default"]
        })),
        React.createElement(MonthSwitchButton, { onClick: function () {
                onMonthChange(addMonths_1["default"](date, 1));
            } }, '>>')));
};
exports["default"] = React.memo(MonthSwitcher);
var templateObject_1, templateObject_2, templateObject_3;
